import { useCallback, useContext } from "react"
import { NormalizerContext } from "../NormalizerContext"
import { useQueryClient } from "@tanstack/react-query"
import qc from "keys/queryClient"


const useInitScoreRating = () => {
    const { checkType, scoreRatingSemesters, activeScoreItemStatus, setActiveScoreItemStatus, activeScoreRatingIndex, stats, setStats, scoreRatingOptions } = useContext(NormalizerContext)

    const queryClient = useQueryClient()

    const initScoreRating = useCallback(() => {
        setActiveScoreItemStatus(null)

        const nStats = []

        scoreRatingSemesters.data?.forEach(scoreRating => {
            let currentData = queryClient.getQueryData([checkType.queryKey, scoreRating.grade, scoreRating.semester, scoreRating.category, scoreRating.method])
            nStats.push(currentData ? currentData.graph : undefined)
        });

        setStats(nStats)
    }, [scoreRatingSemesters, checkType])

    return initScoreRating
}

export default useInitScoreRating